
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archives",
      function () {
        return require("private-next-pages/archives/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archives"])
      });
    }
  